import { PropsWithChildren } from "react";
import { usePlayerContext } from "../../utils/PlayerContext";
import { PlayerStatus } from "../../utils/PlayerUtils";
import styles from "./styles.module.scss";
import clsx from "clsx";

const RootView = ({ children, embedded }: PropsWithChildren<{ embedded: boolean }>) => {
  const { playerStatus } = usePlayerContext();
  return (
    <div
      className={clsx(
        styles.container,
        embedded && styles.embedded,
        playerStatus === PlayerStatus.PLAYING && styles.playing,
      )}
    >
      {children}
    </div>
  );
};
export default RootView;
